<template>
  <div class="repaymentStatusItem">
    <!--头部内容-->
    <div class="header" @click="handleClick()">
      <div class="left">
        <div class="title-wrap">
          <div class="title">
            <img class="icon" src="@/assets/style/order/loan-icon.png" alt="" />
            <span class="title-text">借款额度：{{ item.borrowAmount }}</span>
          </div>
          <div class="right" @click.stop="handlePayAll()">
            <span class="right-btn">立即结清</span>
            <img
              class="right-icon"
              src="@/assets/style/order/right-icon.png"
              alt=""
            />
          </div>
        </div>
        <span class="date">
          <img
            class="contactInfo-icon"
            src="@/assets/style/contactInfo-icon.png"
            alt=""
          />
          <span class="date-text">借款时间：{{ item.createTime }}</span>
        </span>
        <span class="date">
          <img
            class="contactInfo-icon"
            src="@/assets/style/contactInfo-icon.png"
            alt=""
          />
          <span class="date-text">放款时间：{{ item.lendingTime }}</span>
        </span>
      </div>
    </div>
    <!--服务费-->
    <div class="servicefee-wrap" v-if="item.serviceFee > 0">
      <serviceFee :itemData="item" />
    </div>
    <!--还款区域-->
    <div
      class="repayment-content"
      v-for="(data, index) in item.planRespList"
      :key="index"
    >
      <repaymentItem :itemData="data" :num="item.issueOrderNum" />
    </div>
  </div>
</template>

<script>
import repaymentItem from "@/components/orderList/repaymentItem.vue";
import serviceFee from "@/components/orderList/serviceFee.vue";

export default {
  name: "repaymentStatusItem",
  components: {
    repaymentItem,
    serviceFee
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  async mounted() {},
  methods: {
    //点击订单详情
    handleClick() {
      this.$store.commit("setRouterFlag", "1");
      this.$router.push({
        path: "/orderDetails",
        query: {
          borrowOrderId: this.item.borrowOrderId,
        },
      });
    },
    //一键还清
    handlePayAll() {
     this.$emit("payAll",this.item);
    },
  },
};
</script>

<style scoped lang="scss">
.repaymentStatusItem {
  border-radius: 8px;
  padding: 20px 16px 0px 16px;
  background: #fff;
  border: 1px solid #fff;
  margin-bottom: 16px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 100%;
  .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-weight: 500;
      color: #333333;
      display: flex;
      align-items: center;
      .icon {
        height: 30px;
        width: 30px;
        margin-right: 8px;
      }
      .title-text {
        font-size: 17px;
        font-weight: 600;
      }
      .right-icon {
        height: 18px;
      }
    }
  }

  .amount {
    font-weight: 600;
    font-size: 28px;
    color: #333333;
  }
  .date {
    font-size: 11px;
    color: rgba(51, 51, 51, 0.4);
    display: flex;
    align-items: center;
    padding-top: 6px;
    .contactInfo-icon {
      height: 4px;
      width: 4px;
      margin-right: 8px;
    }
    .date-text {
      font-size: 11px;
    }
  }
}
.right {
  font-size: 14px;
  display: flex;
  align-items: center;
  .right-icon {
    height: 12px;
    margin-left: 11px;
  }
}
.right-btn {
  font-weight: 500;
  font-size: 14px;
  color: #F24334;
  padding: 6px 12px;
  border-radius: 26px;
  background: #FFEEEE;
}
</style>
